import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da196870"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex mb-4 justify-content-start"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-2 fw-bold" }, "Chats", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "scroll-y me-n5 pe-5 history-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatUserSearchField = _resolveComponent("ChatUserSearchField")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ChatHistoryEntry = _resolveComponent("ChatHistoryEntry")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.isDrawer ? 'd-flex flex-column w-100' : 'flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0'}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.isDrawer ? '' : 'card card-flush'}`)
    }, [
      (_ctx.isDrawer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.$can('can_start_live_chat', ' all'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(`${_ctx.isDrawer ? 'mb-4' : 'card-header pt-7'}`)
          }, [
            _createVNode(_component_ChatUserSearchField, { onSelectUser: _ctx.handleSelectUser }, null, 8, ["onSelectUser"])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.isDrawer ? 'scroll-y overflow-x-hidden card-body mh-450px' : 'mh-600px card-body pt-5 overflow-scroll'}`)
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
            : (!_ctx.loading && _ctx.history.length == 0)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "No messages yet. Start the conversation!"
                }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.history, (entry) => {
                  return (_openBlock(), _createBlock(_component_ChatHistoryEntry, {
                    onChangeSelectedChat: _cache[0] || (_cache[0] = 
              data =>
                _ctx.$emit('changeSelectedChat', {
                  userId: null,
                  chatId: data.id,
                  chatName: data.chatName,
                  participants: data.participants
                })
            ),
                    key: entry.id,
                    data: entry
                  }, null, 8, ["data"]))
                }), 128))
        ])
      ], 2)
    ], 2)
  ], 2))
}